"use strict";

exports.__esModule = true;
exports.DurationValue = void 0;
var _useUiDesign2 = require("../../Theme/UiDesign/useUiDesign");
var _react = _interopRequireDefault(require("react"));
var _Utils = require("../../../Utils");
var _approximateFontSize = require("../approximateFontSize");
var _constants = require("../../constants");
var _calculateXY2 = require("../calculateXY");
var _excluded = ["width", "height", "value", "fontSize", "textAnchor"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Displays a duration value.
 */
var DurationValue = exports.DurationValue = function DurationValue(props) {
  var _useUiDesign = (0, _useUiDesign2.useUiDesign)(),
    modern = _useUiDesign.modern;
  var width = props.width,
    height = props.height,
    value = props.value,
    fontSize = props.fontSize,
    _props$textAnchor = props.textAnchor,
    textAnchor = _props$textAnchor === void 0 ? _constants.TEXT_ANCHOR_MIDDLE : _props$textAnchor,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var formattedValue = (0, _Utils.formatDuration)(value);
  var autoSize = (0, _approximateFontSize.approximateFontSize)({
    width: width,
    height: height,
    value: formattedValue
  });
  var textSize = modern ? (0, _approximateFontSize.fitFontSize)(fontSize, autoSize) : fontSize || autoSize;
  var _calculateXY = (0, _calculateXY2.calculateXY)({
      width: width,
      height: height,
      textAnchor: textAnchor
    }),
    x = _calculateXY.x,
    y = _calculateXY.y;
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: width,
    height: height
  }, extra, {
    "data-testid": "DurationValue"
  }), /*#__PURE__*/_react["default"].createElement("text", {
    x: x,
    y: y,
    textAnchor: textAnchor
  }, /*#__PURE__*/_react["default"].createElement("tspan", {
    fontSize: textSize,
    fontWeight: "bold",
    alignmentBaseline: "middle"
  }, formattedValue)));
};